<template>
	<div class="common">
		<div class="toplabelsty" v-if="showhide" :class="ismove?'moveparsty':(showhide?'maxtoplabelsty':'')"></div>
		<div class="centconsty" :style="{'min-height':ismove?(showhide?(min_height-270)+'px': min_height+'px'):(showhide?(min_height-480)+'px':(min_height-150)+'px')}">
			<router-view></router-view>
		</div>
		<div class="botfootsty boxsizing" v-if="!ismove">
			<div class="singleparsty boxsizing">
				<img src="../assets/imgs/icon/wechat@2x.png" alt="">
				<span>{{cominfo.name}}</span>
			</div>
			<div class="ctwninparsty">
				版本号：{{cominfo.version}}，
				备案号：<a href="https://beian.miit.gov.cn/" cla target="_blank">{{cominfo.beian}}</a>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "common",
		data() {
			return {
				ismove: false, //是否显示导航
				isshow: false, //是否显示弹窗
				configurat:{}, //配置信息
				showhide: true, //是否显示顶部完整样式
				min_height: window.innerHeight, //窗口的高度
				cominfo: {}, //版权所属
			};
		},
		computed: {

		},
		mounted() {
			this.initFun();
			this.sizeFun();
			window.addEventListener('resize', this.sizeFun);
		},
		methods: {
			// 跳转首页
			tohome() {
				this.$router.push({name: 'Index'});
			},
			// 改变页面大小方法
			sizeFun() {
				setTimeout(() => {
					this.ismove = this.$parent.ismove;
					this.min_height = window.innerHeight;
				}, 100)
			},
			// 页面加载方法
			initFun() {
				if (this.$route.name == 'Index') {
					this.showhide = true;
				} else {
					this.showhide = false;
				}
				var that = this;
				if (this.$utile.locatFun('cominfo')) {
					this.cominfo = JSON.parse(localStorage.getItem('cominfo'));
				} else {
					this.$api.POST(this.$face.user_agreementSet, function(res) {
						localStorage.setItem("cominfo", JSON.stringify(res.data));
						that.cominfo = res.data;
					});
				}
				// 登录方法
				var app_id = this.getUrlParam('app_id'),nickname = this.getUrlParam('nickname'),params = {};
				if(app_id!=null&&app_id!=''&&app_id!=undefined&&app_id!='undefined') {
					params = {
						app_id: app_id,
						member_id: this.getUrlParam('member_id'),
					}
					if(nickname!=null&&nickname!=''&&nickname!=undefined&&nickname!='undefined') {
						console.log(nickname)
						this.$set(params,'nickname',this.getUrlParam('nickname'))
					}
					this.$api.POST(this.$face.app_user,params, function(res) {
						localStorage.setItem("app_id", app_id);
						localStorage.setItem('token', res.data.token);
						localStorage.setItem('userInfor', JSON.stringify(res.data));
					});
				}
			},
			// 获取路径中的参数
			getUrlParam(name) {
				let params_str = location.search.substring(1);
				let params_dic = {};
				params_str.split("&").forEach((item) => {
					let paramItem_list = item.split("=");
					if (paramItem_list.length === 2) {
					params_dic[paramItem_list[0]] = paramItem_list[1];
					}
				});
				return decodeURIComponent(params_dic[name]);
			},
		},
		watch: {
			'$route': function(val) {
				this.initFun();
			}
		}
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.common {
		width: 100%;
		height: auto;
		min-height: 100%;
	}

	.toplabelsty {
		position: relative;
		width: 100%;
		height: 70px;
		background-color: #ffffff;
		box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.08);
	}

	.maxtoplabelsty {
		height: 400px;
		box-shadow: 0px 0px 0px;
		background: url("../assets/imgs/backimg.png") no-repeat;
		background-size: 100% 554px;
		background-position: center top;
	}

	/* 中间区域样式 */
	.centconsty {
		position: relative;
		z-index: 2;
		width: 100%;
		height: auto;
	}

	/* 底部样式 */
	.botfootsty {
		width: 100%;
		height: 80px;
		padding-top: 25px;
		overflow: hidden;
		background-color: rgba(34, 34, 34, 1);
	}

	.singleparsty {
		width: 1320px;
		height: 25px;
		line-height: 25px;
		text-align: right;
		margin: 0px auto;
	}

	.singleparsty>img {
		width: 25px;
		height: 21px;
		margin-right: 5px;
		vertical-align: middle;
	}

	.singleparsty>span {
		font-size: 14px;
		font-weight: 400;
		color: rgba(117, 118, 119, 1);
	}

	@media screen and (max-width: 1320px) {
		.singleparsty {
			width: 100%;
			padding-right: 30px;
		}
	}

	@media screen and (max-width: 950px) {
		.singleparsty {
			width: 100%;
			padding-right: 30px;
		}
	}

	.ctwninparsty,.ctwninparsty a{
		width: 100%;
		height: 30px;
		font-size: 14px;
		font-weight: 400;
		line-height: 20px;
		text-align: center;
		color: rgba(117, 118, 119, 1);
	}
	.ctwninparsty a:hover{
		text-decoration: underline;
	}
	/* 移动端样式 */
	.moveparsty {
		width: 100%;
		height: 270px;
		background: url('../assets/imgs/backimg.png') no-repeat;
		background-size: 100% 100%;
		background-position: left top;
	}
</style>